export const environment = {
	isOnline: true,
	app_url: 'https://preprod.app.legend-binder.com'
};
